import React, { useRef, useState, useEffect } from 'react';
import styles from '../hakuna_batata88/hakuna_batata88.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import catalogoPdf from './src/catalogo-hakuna_batata88.pdf';
import CatalogIcon from '../../icons/catalogIcon.tsx';
import FoodMenuIcon from '../../icons/foodMenuIcon.tsx';

const Hakuna_batata88: React.FC = () => {

    return (
        <div className={styles.hakuna_batata88}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: "200px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1>HAKUNA BATATA</h1>
                    <p className="mb-0">A melhor batata recheada de Bebedouro 😋</p>
                    <p>Delivery / Retirada</p>
                    <div className={styles.links}>
                        <Link
                            href="https://pinktech.com.br/menu/hakuna_batata88"
                            title="Faça seu pedido"
                            icon={<FoodMenuIcon color="#DEAB4E" height="32" />}
                            backgroundColor="#622906"
                            backgroundColorHover="#4a1e03"
                            colorText="#DEAB4E"
                        />
                        <Link
                            href="https://www.instagram.com/hakuna_batata88?igsh=MWZxZWkzbW9jYmhuNg=="
                            title="Instagram"
                            icon={<InstagramIcon color="#DEAB4E" height="32" />}
                            backgroundColor="#622906"
                            backgroundColorHover="#4a1e03"
                            colorText="#DEAB4E"
                        />
                        <Link
                            href="https://wa.me/5517991063217?text=Ol%C3%A1%2C%20gostaria%20de%20fazer%20um%20pedido."
                            title="Whatsapp"
                            icon={<WhatsappIcon color="#DEAB4E" height="40" />}
                            backgroundColor="#622906"
                            backgroundColorHover="#4a1e03"
                            colorText="#DEAB4E"
                        />
                        <Link
                            href={catalogoPdf}
                            title="Catálogo"
                            icon={<CatalogIcon color="#DEAB4E" height="35" />}
                            backgroundColor="#622906"
                            backgroundColorHover="#4a1e03"
                            colorText="#DEAB4E"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hakuna_batata88;
